
import React, { useState } from 'react';

interface FAQProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="py-5 border-b border-gray-200">
      <dt>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-start justify-between w-full text-left text-gray-900"
          aria-expanded={isOpen}
        >
          <span className="text-base font-medium">{question}</span>
          <span className="ml-6 flex h-7 items-center">
            <svg
              className={`h-6 w-6 transform ${isOpen ? '-rotate-180' : 'rotate-0'}`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </span>
        </button>
      </dt>
      {isOpen && (
        <dd className="mt-2 pr-12">
          <p className="text-base text-gray-600">{answer}</p>
        </dd>
      )}
    </div>
  );
};

export default FAQItem;
